import { Typography } from "@/components/ui/typography"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { Info } from "lucide-react"
import { pfasLacksAnnexXvii } from "../../../utils/inquiryScope"
import { regulationKeyLabels } from "../../../utils/regulationLabel"

/** Says which regulations the format has no section for, so the gap is not dropped
 *  silently: in the composer before sending and on a sent inquiry after it. A plain
 *  grey note, not a warning: nothing needs changing before the send (a format that
 *  asks none of them is the composer's own warning, which does hold the send). When PFAS was asked without
 *  Annex XVII, a second line says what the PFAS question still covers (POPs and the
 *  PFAS entries of XVII) and what it leaves out. Renders nothing when there are none
 *  (see `notAskedRegulations`). */
export function InquiryNotAskedNote({
  keys,
  askedRegulations,
  sent = false,
}: {
  keys: readonly string[]
  askedRegulations?: readonly string[] | null
  sent?: boolean
}) {
  const { translate } = useTranslation()
  if (keys.length === 0) return null

  return (
    <div role="status" className="flex items-start gap-2">
      <Info className="mt-0.5 h-3.5 w-3.5 shrink-0 text-grey5" />
      <div className="flex flex-col gap-1">
        <Typography as="muted" className="text-[11.5px] text-grey5">
          {translate(
            sent
              ? "MC_INQ_SENT_REGULATIONS_NOT_ASKED"
              : "MC_INQ_DRAFT_REGULATIONS_NOT_ASKED",
            { list: regulationKeyLabels(keys, translate) },
          )}
        </Typography>
        {pfasLacksAnnexXvii(askedRegulations, keys) && (
          <Typography as="muted" className="text-[11.5px] text-grey5">
            {translate("MC_INQ_REGULATIONS_PFAS_WITHOUT_XVII")}
          </Typography>
        )}
      </div>
    </div>
  )
}
